import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import '../ManagedCDN.css';

const CentralizedMonitoringHe = () => {
    return (
        <div dir="rtl">
            <Helmet>
                {/* Primary Meta Tags */}
                <title>ניטור ורישום מנוהל מרכזי - שירותי NOC 24/7 | Epicfinal</title>
                <meta name="title" content="ניטור ורישום מנוהל מרכזי - שירותי NOC 24/7 | Epicfinal" />
                <meta name="description" content="שירות ניטור מנוהל ב-$490 לחודש. ניטור שרתים ושירותים 24/7, התראות חכמות, מענה קו ראשון, לוח בקרה בענן ודוחות חודשיים. כולל עד 8 שעות עבודה בחודש." />
                <meta name="keywords" content="ניטור מרכזי, ניטור מנוהל, ניטור שרתים, שירותי NOC, ניטור תשתית, ניהול התראות, ניטור שירותים, ניטור ענן, ניטור 24/7, ניטור ביצועים, ניטור זמינות, ניטור משאבים, ניהול לוגים" />
                <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
                <meta name="author" content="Epicfinal" />
                <link rel="canonical" href="https://epicfinal.com/he/centralized-monitoring" />

                {/* Language & Locale */}
                <html lang="he" />
                <meta property="og:locale" content="he_IL" />
                <link rel="alternate" href="https://epicfinal.com/centralized-monitoring" hrefLang="en" />
                <link rel="alternate" href="https://epicfinal.com/he/centralized-monitoring" hrefLang="he" />

                {/* Open Graph / Facebook */}
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://epicfinal.com/he/centralized-monitoring" />
                <meta property="og:title" content="ניטור ורישום מנוהל מרכזי | Epicfinal" />
                <meta property="og:description" content="ניטור מנוהל 24/7 ב-$490 לחודש. התראות חכמות, מענה קו ראשון, לוח בקרה בענן ודוחות חודשיים." />
                <meta property="og:image" content="https://epicfinal.com/android-chrome-512x512.png" />
                <meta property="og:image:alt" content="Epicfinal ניטור מרכזי - שירותי NOC 24/7" />
                <meta property="og:site_name" content="Epicfinal" />

                {/* Twitter */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:url" content="https://epicfinal.com/he/centralized-monitoring" />
                <meta name="twitter:title" content="ניטור ורישום מנוהל מרכזי | Epicfinal" />
                <meta name="twitter:description" content="ניטור מנוהל 24/7 ב-$490 לחודש. התראות חכמות ומענה קו ראשון." />
                <meta name="twitter:image" content="https://epicfinal.com/android-chrome-512x512.png" />

                {/* Schema.org Structured Data */}
                <script type="application/ld+json">{`
                    {
                        "@context": "https://schema.org",
                        "@type": "Service",
                        "name": "ניטור ורישום מנוהל מרכזי",
                        "description": "שירות ניטור מנוהל מלא הכולל פריסת סוכנים חכמים, ניטור התראות 24/7, מענה קו ראשון, לוח בקרה בענן ודוחות סטטוס חודשיים",
                        "provider": {"@type": "Organization", "name": "Epicfinal", "url": "https://epicfinal.com"},
                        "serviceType": "ניטור תשתית",
                        "areaServed": "Worldwide",
                        "offers": {"@type": "Offer", "price": "490.00", "priceCurrency": "USD", "priceValidUntil": "2025-12-31", "availability": "https://schema.org/InStock"},
                        "url": "https://epicfinal.com/he/centralized-monitoring"
                    }
                `}</script>
            </Helmet>

            <div className="managed-cdn-page">
                <section className="cdn-hero">
                    <div className="container">
                        <div className="cdn-hero-content">
                            <div className="cdn-icon-badge">
                                <i className="las la-chart-line"></i>
                            </div>
                            <h1 className="cdn-hero-title">
                                ניטור ורישום מנוהל מרכזי
                            </h1>
                            <p className="cdn-hero-subtitle">
                                ניטור שרתים ושירותים מנוהל
                            </p>
                            <p className="cdn-hero-description">
                                אנו מספקים ניטור מנוהל מלא לשרתים ולשירותים הקריטיים שלכם, באמצעות סוכן ניטור חכם ולוח בקרה מבוסס ענן. הצוות שלנו מגדיר ספים (Thresholds), עוקב אחר התראות ומספק מענה ראשוני, כדי שתקלות יזוהו מוקדם ויטופלו במהירות.
                            </p>
                            <div className="cdn-hero-buttons">
                                <a href="https://my.epicfinal.com/index.php?rp=/store/managed-services/managed-centralized-logging-and-monitoring&language=hebrew&currency=2"
                                    className="btn-cdn btn-primary" target="_blank" rel="noopener noreferrer">
                                    הזמינו עכשיו - ₪1760.00 לחודש
                                </a>
                                <Link to="/contact1" className="btn-cdn btn-secondary">
                                    דברו עם מומחה
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="cdn-features">
                    <div className="container">
                        <div className="cdn-section-header">
                            <h2>פתרון ניטור מקיף</h2>
                            <p>ניטור פרואקטיבי עם מענה של מומחים</p>
                        </div>
                        <div className="cdn-features-grid">
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-server"></i>
                                </div>
                                <h3>ניטור משאבים</h3>
                                <p>מעקב רציף אחר ניצול מעבד, זיכרון, דיסק ורשת בכל התשתית שלכם.</p>
                            </div>
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-heartbeat"></i>
                                </div>
                                <h3>בדיקות בריאות שירותים</h3>
                                <p>ניטור שרתי אינטרנט, מסדי נתונים, אפליקציות ושירותים קריטיים, לשמירה על זמינות מרבית.</p>
                            </div>
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-bell"></i>
                                </div>
                                <h3>ניהול התראות</h3>
                                <p>התראות חכמות עם הגדרת ספים ותהליכי הסלמה מובנים.</p>
                            </div>
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-user-shield"></i>
                                </div>
                                <h3>מענה קו ראשון</h3>
                                <p>הצוות שלנו מבצע מיון ראשוני ומספק מענה להתראות קריטיות.</p>
                            </div>
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-chart-area"></i>
                                </div>
                                <h3>לוח בקרה בענן</h3>
                                <p>נראות בזמן אמת לתשתית שלכם עם מדדים וגרפים מפורטים.</p>
                            </div>
                            <div className="cdn-feature-card">
                                <div className="cdn-feature-icon">
                                    <i className="las la-file-alt"></i>
                                </div>
                                <h3>דוחות חודשיים</h3>
                                <p>סיכומי סטטוס מקיפים עם תובנות ביצועים והמלצות לשיפור.</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="cdn-included">
                    <div className="container">
                        <div className="cdn-section-header">
                            <h2>מה כלול בשירות</h2>
                            <p>ניהול ניטור והתראות מלא</p>
                        </div>
                        <div className="cdn-included-grid">
                            <div className="cdn-included-column">
                                <h3><i className="las la-check-circle"></i> הגדרת ניטור</h3>
                                <ul>
                                    <li><i className="las la-angle-right"></i> פריסת סוכני ניטור חכמים</li>
                                    <li><i className="las la-angle-right"></i> הגדרת ניטור משאבים</li>
                                    <li><i className="las la-angle-right"></i> בדיקות בריאות שירותים</li>
                                    <li><i className="las la-angle-right"></i> הגדרת ספים בהתאמה אישית</li>
                                </ul>
                            </div>
                            <div className="cdn-included-column">
                                <h3><i className="las la-check-circle"></i> טיפול בהתראות</h3>
                                <ul>
                                    <li><i className="las la-angle-right"></i> ניטור התראות רציף</li>
                                    <li><i className="las la-angle-right"></i> מיון וסיווג התראות</li>
                                    <li><i className="las la-angle-right"></i> מענה קו ראשון לתקלות</li>
                                    <li><i className="las la-angle-right"></i> תהליכי הסלמה מסודרים</li>
                                </ul>
                            </div>
                            <div className="cdn-included-column">
                                <h3><i className="las la-check-circle"></i> דוחות ותמיכה</h3>
                                <ul>
                                    <li><i className="las la-angle-right"></i> סיכום סטטוס חודשי</li>
                                    <li><i className="las la-angle-right"></i> ניתוח ביצועים</li>
                                    <li><i className="las la-angle-right"></i> עד 8 שעות עבודה בחודש</li>
                                    <li><i className="las la-angle-right"></i> תמיכה טכנית מומחית</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Pricing Section */}
                <section className="cdn-pricing">
                    <div className="container">
                        <div className="cdn-pricing-card">
                            <div className="cdn-pricing-header">
                                <h2>שירות ניטור מרכזי</h2>
                                <p>ניהול ניטור והתראות מלא</p>
                            </div>
                            <div className="cdn-pricing-body">
                                <div className="cdn-pricing-amount">
                                    <span className="cdn-price">$490.00</span>
                                    <span className="cdn-period">חודשי / USD</span>
                                </div>
                                <ul className="cdn-pricing-features">
                                    <li><i className="las la-check"></i> פריסת סוכני ניטור חכמים</li>
                                    <li><i className="las la-check"></i> ניטור משאבים רציף</li>
                                    <li><i className="las la-check"></i> בדיקות שירות וזמינות</li>
                                    <li><i className="las la-check"></i> ניטור התראות 24/7</li>
                                    <li><i className="las la-check"></i> מיון ומענה להתראות</li>
                                    <li><i className="las la-check"></i> לוח בקרה מבוסס ענן</li>
                                    <li><i className="las la-check"></i> דוחות סטטוס חודשיים</li>
                                    <li><i className="las la-check"></i> עד 8 שעות עבודה בחודש</li>
                                </ul>
                                <div className="cdn-pricing-note">
                                    <i className="las la-info-circle"></i>
                                    <p><strong>הערה:</strong> לא כולל רישיונות לפלטפורמת הניטור או עלויות ספק ענן.</p>
                                </div>
                                <a href="https://my.epicfinal.com/index.php?rp=/store/managed-services/managed-centralized-logging-and-monitoring&language=hebrew&currency=2"
                                    className="cdn-pricing-btn" target="_blank" rel="noopener noreferrer">
                                    התחילו עכשיו
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                {/* CTA Section */}
                <section className="cdn-cta">
                    <div className="container">
                        <div className="cdn-cta-content">
                            <h2>מוכנים לניטור פרואקטיבי?</h2>
                            <p>עקבו אחר התשתית שלכם באופן פרואקטיבי והגיבו לתקלות במהירות.</p>
                            <div className="cdn-cta-buttons">
                                <a href="https://my.epicfinal.com/index.php?rp=/store/managed-services/managed-centralized-logging-and-monitoring&language=hebrew&currency=2"
                                    className="btn-cdn btn-light" target="_blank" rel="noopener noreferrer">
                                    הזמינו שירות
                                </a>
                                <a href="https://meetings.hubspot.com/viacheslav-seifer"
                                    className="btn-cdn btn-outline" target="_blank" rel="noopener noreferrer">
                                    קבעו שיחת ייעוץ
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default CentralizedMonitoringHe;
